export default "__VITE_ASSET__6xGHHB4p__"